import React, { useEffect, useState } from "react";
import "../styles/OverallVolatilityIndicatorSection.scss";
import { API, graphqlOperation } from "aws-amplify";

function OverallVolatilityIndicatorSection(props) {
  useEffect(() => {
    //Get realized volatility data to display on table.
    async function getRealizedVolatilityData() {
      try {
        let todayDate = new Date();
        todayDate = todayDate.toLocaleDateString("fr-CA");
        let ninetyDayDate = new Date();
        ninetyDayDate = ninetyDayDate.setDate(ninetyDayDate.getDate() - 90);
        ninetyDayDate = new Date(ninetyDayDate).toLocaleDateString("fr-CA");
        const response = await API.graphql(
          graphqlOperation(`{
        get_charting_data(object: {data: {ticker: "${props.original.ticker}", from: "${ninetyDayDate}", to: "${todayDate}", interval: "daily", fields: ["timestamp", "volatility_30d"]}}) {
          data
        }
      }`),
        );
        const realizedVolatilityData = [];
        realizedVolatilityData.push(
          response.data.get_charting_data.data[
            response.data.get_charting_data.data.length - 1
          ].volatility_30d,
        );
        realizedVolatilityData.push(
          response.data.get_charting_data.data[
            response.data.get_charting_data.data.length - 6
          ].volatility_30d,
        );
        realizedVolatilityData.push(
          response.data.get_charting_data.data[
            response.data.get_charting_data.data.length - 31
          ].volatility_30d,
        );
        if (response.data.get_charting_data.data[1])
          realizedVolatilityData.push(
            response.data.get_charting_data.data[1].volatility_30d,
          );
        setRealizedVolatilityData(realizedVolatilityData);
      } catch (err) {
        console.log(err);
      }
    }
    getRealizedVolatilityData();
  }, [props.original.ticker]);

  const [realizedVolatilityData, setRealizedVolatilityData] = useState([]);

  const pxLast = parseFloat(props.original.px_last);
  const pxClose = parseFloat(props.original.px_close_1d);
  const stSignal = props.original.algo.data[`30D_ST_MOMENTUM`];
  const mtSignal = props.original.algo.data[`90D_MT_MOMENTUM`];
  const pxStSignal = parseFloat(props.original.algo.data[`30D_ST_PRICE`]);
  const pxMtSignal = parseFloat(props.original.algo.data[`90D_MT_PRICE`]);
  const isStBroken = ["BEARISH", "BULLISH", "NEUTRAL"].includes(stSignal)
    ? pxClose < pxStSignal
      ? pxLast > pxStSignal
      : pxLast < pxStSignal
    : false;
  const isMtBroken = ["BEARISH", "BULLISH", "NEUTRAL"].includes(mtSignal)
    ? pxClose < pxMtSignal
      ? pxLast > pxMtSignal
      : pxLast < pxMtSignal
    : false;

  return (
    <div className="overall-inidicators-volatility">
      <div className="indicators-volatility">
        {/* MOMENTUM INDICATOR section */}
        <div
          className="momentum-indicator"
          style={{
            background:
              props.chartDisplay === "Momentum-Indicator-Chart"
                ? "#171717"
                : null,
            paddingBottom: 7,
          }}
          onClick={() => props.setChartDisplay("Momentum-Indicator-Chart")}
        >
          <div className="momentum-indicator-title">Momentum Indicator</div>
          <div className="sub-header">
            <div
              className="sub-header-text"
              style={{ color: "#BBB8B8" }}
            >{`Short Term`}</div>
            <div
              className="sub-header-text"
              style={{ color: "#BBB8B8" }}
            >{`Medium Term`}</div>
          </div>

          <div className="main-info">
            <div className="indicator-section">
              <div className="type" style={{ color: "#BBB8B8" }}>
                Signal
              </div>
              {/* Short Term Signal */}
              {isStBroken ? (
                <div style={{ position: "relative" }}>
                  <img
                    style={{ width: 69 }}
                    src={`/broken_${stSignal.toLowerCase()}.svg`}
                  />
                  <span
                    style={{
                      textTransform: "capitalize",
                      position: "absolute",
                      textAlign: "center",
                      top: 3,
                      width: 68,
                      color: "#fff",
                    }}
                  >
                    {stSignal.toLowerCase()}
                  </span>
                </div>
              ) : (
                <div
                  style={{ height: 20, width: 60 }}
                  className={
                    Math.max(props.algo.data["CALC_TRADE_RANGE_HIGH"]) === -1 ||
                    Math.max(props.algo.data["CALC_TRADE_RANGE_LOW"]) === -1
                      ? "neutral-pill empty-value"
                      : props.original.algo.data["30D_ST_MOMENTUM"] ===
                        "BULLISH"
                      ? "indicator-pill green-background"
                      : props.original.algo.data["30D_ST_MOMENTUM"] ===
                        "BEARISH"
                      ? "indicator-pill red-background"
                      : props.original.algo.data["30D_ST_MOMENTUM"] ===
                        "NEUTRAL"
                      ? "neutral-pill"
                      : "neutral-pill empty-value"
                  }
                >
                  <span style={{ position: "relative", top: 0.5 }}>
                    {Math.max(props.algo.data["CALC_TRADE_RANGE_HIGH"]) ===
                      -1 ||
                    Math.max(props.algo.data["CALC_TRADE_RANGE_LOW"]) === -1
                      ? "- - -"
                      : props.original.algo.data["30D_ST_MOMENTUM"] ===
                        "BULLISH"
                      ? "Bullish"
                      : props.original.algo.data["30D_ST_MOMENTUM"] ===
                        "BEARISH"
                      ? "Bearish"
                      : props.original.algo.data["30D_ST_MOMENTUM"] ===
                        "NEUTRAL"
                      ? "Neutral"
                      : "- - -"}
                  </span>
                </div>
              )}
            </div>
            <div className="indicator-section">
              <div className="type" style={{ color: "#BBB8B8" }}>
                Price
              </div>
              <div className="info">
                {/* Short Term Price */}
                <span
                  style={
                    props.algo.data["30D_ST_PRICE"] &&
                    (Math.max(props.algo.data["CALC_TRADE_RANGE_HIGH"]) !==
                      -1) &
                      (Math.max(props.algo.data["CALC_TRADE_RANGE_LOW"]) !== -1)
                      ? { color: "white" }
                      : { color: "#666666" }
                  }
                >
                  {props.algo.data["30D_ST_PRICE"] &&
                  props.algo.data["30D_ST_PRICE"] > 0 &&
                  (Math.max(props.algo.data["CALC_TRADE_RANGE_HIGH"]) !== -1) &
                    (Math.max(props.algo.data["CALC_TRADE_RANGE_LOW"]) !== -1)
                    ? props.algo.data["30D_ST_PRICE"] >= 10000
                      ? props.noDecimals(props.algo.data["30D_ST_PRICE"])
                      : props.original.ticker.includes("Curncy")
                      ? props.algo.data["30D_ST_PRICE"].toFixed(4)
                      : props.usCurrency(props.algo.data["30D_ST_PRICE"])
                    : "- - -"}
                </span>
              </div>
            </div>
            <div className="indicator-section">
              <div className="type" style={{ color: "#BBB8B8" }}>
                Signal
              </div>
              {/* Medium Term Signal */}
              {isMtBroken ? (
                <div style={{ position: "relative" }}>
                  <img
                    style={{ width: 69 }}
                    src={`/broken_${mtSignal.toLowerCase()}.svg`}
                  />
                  <span
                    style={{
                      textTransform: "capitalize",
                      position: "absolute",
                      textAlign: "center",
                      top: 3,
                      width: 68,
                      color: "#fff",
                    }}
                  >
                    {mtSignal.toLowerCase()}
                  </span>
                </div>
              ) : (
                <div
                  style={{ height: 20, width: 60 }}
                  className={
                    Math.max(props.algo.data["CALC_TRADE_RANGE_HIGH"]) === -1 ||
                    Math.max(props.algo.data["CALC_TRADE_RANGE_LOW"]) === -1
                      ? "neutral-pill empty-value"
                      : props.original.algo.data["90D_MT_MOMENTUM"] ===
                        "BULLISH"
                      ? "indicator-pill green-background"
                      : props.original.algo.data["90D_MT_MOMENTUM"] ===
                        "BEARISH"
                      ? "indicator-pill red-background"
                      : props.original.algo.data["90D_MT_MOMENTUM"] ===
                        "NEUTRAL"
                      ? "indicator-pill grey-background"
                      : "empty-value-pill"
                  }
                >
                  <span>
                    {Math.max(props.algo.data["CALC_TRADE_RANGE_HIGH"]) ===
                      -1 ||
                    Math.max(props.algo.data["CALC_TRADE_RANGE_LOW"]) === -1
                      ? "- - -"
                      : props.original.algo.data["90D_MT_MOMENTUM"] ===
                        "BULLISH"
                      ? "Bullish"
                      : props.original.algo.data["90D_MT_MOMENTUM"] ===
                        "BEARISH"
                      ? "Bearish"
                      : props.original.algo.data["90D_MT_MOMENTUM"] ===
                        "NEUTRAL"
                      ? "Neutral"
                      : "- - -"}
                  </span>
                </div>
              )}
            </div>
            <div className="indicator-section">
              <div className="type" style={{ color: "#BBB8B8" }}>
                Price
              </div>
              <div className="info">
                {/* Medium Term Price */}
                <span
                  style={
                    props.algo.data["90D_MT_PRICE"] &&
                    (Math.max(props.algo.data["CALC_TRADE_RANGE_HIGH"]) !==
                      -1) &
                      (Math.max(props.algo.data["CALC_TRADE_RANGE_LOW"]) !== -1)
                      ? { color: "white" }
                      : { color: "#666666" }
                  }
                >
                  {props.algo.data["90D_MT_PRICE"] &&
                  props.algo.data["90D_MT_PRICE"] > 0 &&
                  (Math.max(props.algo.data["CALC_TRADE_RANGE_HIGH"]) !== -1) &
                    (Math.max(props.algo.data["CALC_TRADE_RANGE_LOW"]) !== -1)
                    ? props.algo.data["90D_MT_PRICE"] > 10000
                      ? props.noDecimals(props.algo.data["90D_MT_PRICE"])
                      : props.original.ticker.includes("Curncy")
                      ? props.algo.data["90D_MT_PRICE"].toFixed(4)
                      : props.usCurrency(props.algo.data["90D_MT_PRICE"])
                    : "- - -"}
                </span>
              </div>
            </div>
          </div>
        </div>
        {/* IMPLIED VOLATILITY section */}
        <div
          className="implied-volatility"
          style={{
            background:
              props.chartDisplay === "Implied-Volatility-Chart"
                ? "#171717"
                : null,
            cursor: "pointer",
          }}
          onClick={() => props.setChartDisplay("Implied-Volatility-Chart")}
        >
          <div className="implied-title-section">
            <span style={{ paddingRight: 10 }}>Implied Volatility</span>
            <div
              className={`indicator-pill ${
                props.original.algo.data["IVOL_SIGNAL"] === "Greed"
                  ? "red"
                  : props.original.algo.data["IVOL_SIGNAL"] === "Fear"
                  ? "green"
                  : props.original.algo.data["IVOL_SIGNAL"] === "Neutral"
                  ? "grey"
                  : "empty-value"
              }-background`}
            >
              {props.original.algo.data["IVOL_SIGNAL"] &&
              props.original.algo.data["IVOL_SIGNAL"] !== "NA"
                ? props.original.algo.data["IVOL_SIGNAL"] === "Greed"
                  ? "Discount"
                  : props.original.algo.data["IVOL_SIGNAL"] === "Fear"
                  ? "Premium"
                  : "Neutral"
                : "- - -"}
            </div>
          </div>

          <div className="discount">(Discount) / Premium</div>
          <div className="implied-table">
            <div className="implied-section">
              <div className="type" style={{ color: "#BBB8B8" }}>
                1D
              </div>
              <div
                className="info"
                style={{
                  color:
                    props.original.algo_CurrImpVolDiscPrem < 0
                      ? "#d33541"
                      : props.original.algo_CurrImpVolDiscPrem > 0
                      ? "#75ce41"
                      : "#666666",
                }}
              >
                {props.original.algo_CurrImpVolDiscPrem
                  ? parseInt(props.original.algo_CurrImpVolDiscPrem * 100) + "%"
                  : "- - -"}
              </div>
            </div>

            <div className="implied-section">
              <div className="type" style={{ color: "#BBB8B8" }}>
                1W
              </div>

              <div
                className="info"
                style={{
                  color:
                    props.original.algo_CurrImpVolDiscPrem7D < 0
                      ? "#d33541"
                      : props.original.algo_CurrImpVolDiscPrem7D > 0
                      ? "#75ce41"
                      : "#666666",
                }}
              >
                {props.original.algo_CurrImpVolDiscPrem7D
                  ? parseInt(props.original.algo_CurrImpVolDiscPrem7D * 100) +
                    "%"
                  : "- - -"}
              </div>
            </div>
            <div className="implied-section">
              <div className="type" style={{ color: "#BBB8B8" }}>{`1M`}</div>
              <div
                className="info"
                style={{
                  color:
                    props.original.algo_CurrImpVolDiscPrem30D < 0
                      ? "#d33541"
                      : props.original.algo_CurrImpVolDiscPrem30D > 0
                      ? "#75ce41"
                      : "#666666",
                }}
              >
                {props.original.algo_CurrImpVolDiscPrem30D
                  ? parseInt(props.original.algo_CurrImpVolDiscPrem30D * 100) +
                    "%"
                  : "- - -"}
              </div>
            </div>
            <div className="implied-section">
              <div className="type" style={{ color: "#BBB8B8" }}>{`3M`}</div>
              <div
                className="info"
                style={{
                  color:
                    props.original.algo_CurrImpVolDiscPrem90D < 0
                      ? "#d33541"
                      : props.original.algo_CurrImpVolDiscPrem90D > 0
                      ? "#75ce41"
                      : "#666666",
                }}
              >
                {props.original.algo_CurrImpVolDiscPrem90D
                  ? parseInt(props.original.algo_CurrImpVolDiscPrem90D * 100) +
                    "%"
                  : "- - -"}
              </div>
            </div>
          </div>
        </div>
        {/* REALIZED VOLATILITY section */}
        <div
          className="realized-volatility"
          style={{
            background:
              props.chartDisplay === "Realized-Volatility-Chart"
                ? "#171717"
                : null,
            cursor: "pointer",
            borderRight: "1px solid #2e2e2e",
          }}
          onClick={() => props.setChartDisplay("Realized-Volatility-Chart")}
        >
          <div className="realized-title" style={{ paddingBottom: 22 }}>
            Realized Volatility
          </div>
          <div className="change-table">
            <div className="change-section">
              <div className="type" style={{ color: "#BBB8B8" }}>{`1D`}</div>
              <div
                className={`info ${
                  realizedVolatilityData[0] > 0
                    ? "green"
                    : realizedVolatilityData[0] < 0
                    ? "red"
                    : realizedVolatilityData[0] === 0
                    ? "neutral"
                    : "empty-value"
                }`}
              >
                <span>
                  {realizedVolatilityData[0]
                    ? parseInt(realizedVolatilityData[0]) + "%"
                    : "- - -"}
                </span>
              </div>
            </div>
            <div className="change-section">
              <div className="type" style={{ color: "#BBB8B8" }}>{`1W`}</div>
              <div
                className={`info ${
                  realizedVolatilityData[1] > 0
                    ? "green"
                    : realizedVolatilityData[1] < 0
                    ? "red"
                    : realizedVolatilityData[1] === 0
                    ? "neutral"
                    : "empty-value"
                }`}
              >
                <span>
                  {realizedVolatilityData[1]
                    ? parseInt(realizedVolatilityData[1]) + "%"
                    : "- - -"}
                </span>
              </div>
            </div>
            <div className="change-section">
              <div className="type" style={{ color: "#BBB8B8" }}>{`1M`}</div>
              <div
                className={`info ${
                  realizedVolatilityData[2] > 0
                    ? "green"
                    : realizedVolatilityData[2] < 0
                    ? "red"
                    : realizedVolatilityData[2] === 0
                    ? "neutral"
                    : "empty-value"
                }`}
              >
                <span>
                  {realizedVolatilityData[2]
                    ? parseInt(realizedVolatilityData[2]) + "%"
                    : "- - -"}
                </span>
              </div>
            </div>
            <div className="change-section">
              <div className="type" style={{ color: "#BBB8B8" }}>{`3M`}</div>
              <div
                className={`info ${
                  realizedVolatilityData[3] > 0
                    ? "green"
                    : realizedVolatilityData[3] < 0
                    ? "red"
                    : realizedVolatilityData[3] === 0
                    ? "neutral"
                    : "empty-value"
                }`}
              >
                <span>
                  {realizedVolatilityData[3]
                    ? parseInt(realizedVolatilityData[3]) + "%"
                    : "- - -"}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default React.memo(OverallVolatilityIndicatorSection);
